export default {
  // Endpoints
  loginEndpoint: 'https://proxy.dap.rocks/ganapp.dap.rocks/api/login',
  registerEndpoint: 'https://proxy.dap.rocks/ganapp.dap.rocks/api/register',
  refreshEndpoint: '/jwt/refresh-token',
  logoutEndpoint: '/jwt/logout',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
}
